import React from 'react'
import PropTypes from 'prop-types'

import RoleOption from '../role-option'

const RoleQuestion = ({
  title,
  options,
  onSelected,
  allowSearch,
  children,
  colour
}) => (
  <div className='role-question'>
    <div className='g--font-h4--body'>{title}</div>

    {options.map((option, index) =>
      typeof option === 'string' ? (
        <RoleOption
          key={index}
          title={option}
          onClick={() => {
            onSelected(option)
          }}
          colour={colour}
        />
      ) : (
        <RoleOption
          key={index}
          title={option.name}
          salary={option.salary}
          demand={option.demand}
          onClick={() => {
            onSelected(option.name)
          }}
          colour={colour}
        />
      )
    )}
    {allowSearch && <>{children}</>}
  </div>
)

RoleQuestion.defaultProps = {
  title: 'What do you want to do next?',
  options: [],
  allowSearch: false,
  colour: false
}

RoleQuestion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      })
    ),
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onSelected: PropTypes.func.isRequired,
  allowSearch: PropTypes.bool
}

export default RoleQuestion
